import React, { useEffect, useState } from 'react';
import { Card, Form, Button, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getSiteById, updateSite } from 'services/sites';
import UploadSiteLogo from '../components/uploadSiteLogo';
import { toast } from 'react-toastify';

const EditSite = () => {
  const [siteData, setSiteData] = useState({
    name: '',
    is_active: 1
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  // Recupera el ID del sitio desde localStorage
  const siteId = localStorage.getItem('selectedSiteId');

  useEffect(() => {
    if (!siteId) {
      toast.error('No se encontró el ID del sitio.', { theme: 'colored' });
      navigate('/sites');
      return;
    }
    setLoading(true);
    getSiteById(siteId)
      .then(data => {
        if (data && data.id) {
          console.log('Datos del sitio:', data);
          setSiteData({
            name: data.name || '',
            is_active: data.is_active ? 1 : 0,
            image_url: data.image_url || null,
            header_color: data.header_color || '',
            footer_color: data.footer_color || '',
            domain_name: data.domain_name || ''
          });
        } else {
          toast.error('No se encontró el sitio.', { theme: 'colored' });
          navigate('/sites');
        }
        setLoading(false);
      })
      .catch(() => {
        toast.error('Error al cargar el sitio.', { theme: 'colored' });
        setLoading(false);
        navigate('/sites');
      });
  }, [siteId, navigate]);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setSiteData({
      ...siteData,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : value
    });
    setErrors({
      ...errors,
      [name]: ''
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!siteData.name.trim()) newErrors.name = 'El nombre es requerido.';
    if (!siteData.domain_name.trim())
      newErrors.domain_name = 'El dominio es requerido.';
    return newErrors;
  };

  const handleSubmit = e => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error('Por favor, completa todos los campos requeridos.', {
        theme: 'colored'
      });
      return;
    }
    setSaving(true);
    updateSite(
      siteId,
      siteData.name,
      siteData.is_active,
      siteData.header_color,
      siteData.footer_color,
      siteData.domain_name
    )
      .then(response => {
        if (response.result) {
          toast.success('Sitio actualizado exitosamente.', {
            theme: 'colored'
          });
          navigate('/sites');
        } else {
          toast.error('Error al actualizar el sitio.', { theme: 'colored' });
        }
        setSaving(false);
      })
      .catch(() => {
        toast.error('Error al actualizar el sitio.', { theme: 'colored' });
        setSaving(false);
      });
  };

  if (loading) {
    return (
      <div className="text-center py-4">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <>
      <Card>
        <Card.Header>
          <h5>Editar Sitio</h5>
        </Card.Header>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>
                Nombre <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={siteData.name}
                onChange={handleChange}
                isInvalid={!!errors.name}
                placeholder="Nombre del sitio"
                size="sm"
              />
              <Form.Control.Feedback type="invalid">
                {errors.name}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Estado</Form.Label>
              <div>
                <Form.Check
                  type="checkbox"
                  name="is_active"
                  checked={siteData.is_active === 1}
                  onChange={handleChange}
                  label={siteData.is_active === 1 ? 'Activo' : 'Inactivo'}
                  className="mt-2"
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Color Header</Form.Label>
              <div style={{ display: 'flex', gap: 8 }}>
                <Form.Control
                  type="color"
                  name="header_color"
                  value={siteData.header_color || '#000000'}
                  onChange={e =>
                    setSiteData({ ...siteData, header_color: e.target.value })
                  }
                  style={{ width: 40, padding: 0 }}
                  title="Selecciona un color"
                />
                <Form.Control
                  type="text"
                  name="header_color"
                  value={siteData.header_color || ''}
                  onChange={e =>
                    setSiteData({ ...siteData, header_color: e.target.value })
                  }
                  placeholder="Pega un valor HEX o RGBA"
                  size="sm"
                />
              </div>
              <Form.Text className="text-muted">
                Puedes seleccionar un color o pegar un valor como{' '}
                <code>#ff0000</code> o <code>rgba(255,0,0,1)</code>
              </Form.Text>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Color Footer</Form.Label>
              <div style={{ display: 'flex', gap: 8 }}>
                <Form.Control
                  type="color"
                  name="footer_color"
                  value={siteData.footer_color || '#000000'}
                  onChange={e =>
                    setSiteData({ ...siteData, footer_color: e.target.value })
                  }
                  style={{ width: 40, padding: 0 }}
                  title="Selecciona un color"
                />
                <Form.Control
                  type="text"
                  name="footer_color"
                  value={siteData.footer_color || ''}
                  onChange={e =>
                    setSiteData({ ...siteData, footer_color: e.target.value })
                  }
                  placeholder="Pega un valor HEX o RGBA"
                  size="sm"
                />
              </div>
              <Form.Text className="text-muted">
                Puedes seleccionar un color o pegar un valor como{' '}
                <code>#ff0000</code> o <code>rgba(255,0,0,1)</code>
              </Form.Text>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>
                Dominio <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="domain_name"
                value={siteData.domain_name}
                onChange={handleChange}
                isInvalid={!!errors.domain_name}
                placeholder="Ejemplo: midominio.com"
                size="sm"
              />
              <Form.Control.Feedback type="invalid">
                {errors.domain_name}
              </Form.Control.Feedback>
            </Form.Group>
            <Button variant="primary" type="submit" size="sm" disabled={saving}>
              {saving ? 'Guardando...' : 'Guardar Cambios'}
            </Button>
          </Form>
        </Card.Body>
      </Card>
      {siteId && siteId !== 0 && (
        <UploadSiteLogo siteId={siteId} image_url={siteData.image_url} />
      )}
    </>
  );
};

export default EditSite;
